import type { GovernanceFormSchema } from '../schemas';

export const defaultValues: Readonly<GovernanceFormSchema> = {
  id: -1,
  jurisdiction: '',
  registration_number: '',
  registered_agent_name: '',
  registered_agent_addresses: [],
  notes: '',
  supporting_documentation: [],
  legal_business_name: '',
};
